import { render, staticRenderFns } from "./UserAssociations.vue?vue&type=template&id=3d65c7bc&"
import script from "./UserAssociations.vue?vue&type=script&lang=js&"
export * from "./UserAssociations.vue?vue&type=script&lang=js&"
import style0 from "./UserAssociations.vue?vue&type=style&index=0&id=3d65c7bc&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d65c7bc')) {
      api.createRecord('3d65c7bc', component.options)
    } else {
      api.reload('3d65c7bc', component.options)
    }
    module.hot.accept("./UserAssociations.vue?vue&type=template&id=3d65c7bc&", function () {
      api.rerender('3d65c7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/UserAssociations.vue"
export default component.exports